import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';


const ModuleNotExcessModal = ({moduleName, leaseNotFound}) => {

    const navigate = useNavigate();

    return (
        <Dialog open={true} fullWidth maxWidth={leaseNotFound ? "sm" : "md"}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningAmberIcon sx={{ color: 'error.main' }} />
                {leaseNotFound ? "Lease Not Found" : "Access Restricted – Lease in Draft"}
            </DialogTitle>
            <DialogContent dividers>
                <Typography>
                    {leaseNotFound
                        ? "The lease could not be found. Please go back to the lease listing."
                        : <>This module is not accessible because the lease is currently in <strong>Draft</strong> status. Please activate the lease to access {moduleName}.</>
                    }
                </Typography>
            </DialogContent>
            <DialogActions sx={{ marginRight: "15px" }}>
                <Button
                    variant="contained"
                    size='small'
                    onClick={() => navigate('/leases', { replace: true })}
                >
                    Back to Lease Listing
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModuleNotExcessModal